import { render, staticRenderFns } from "./FormTemplateDetailsCard.vue?vue&type=template&id=4f278c4d&scoped=true&"
import script from "./FormTemplateDetailsCard.vue?vue&type=script&lang=js&"
export * from "./FormTemplateDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateDetailsCard.vue?vue&type=style&index=0&id=4f278c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f278c4d",
  null
  
)

export default component.exports